export const LOGIN_REQUESTING = 'LOGIN_REQUESTING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_EXISTING = 'LOGIN_EXISTING';
export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGOUT = 'LOGOUT';
